import {absCenter, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    padding: 0,
    float: 'right'
  },
  content: {
    padding: '8px',
    border: '1px solid rgba(0,22,66,0.32)',
    background: '#fafdfe',
    position: 'absolute',
    top: '40px',
    left: 0,
    width: '100%',
    zIndex: 1,
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
  },
  uploadContactsDescription: {
    fontSize: '1.4rem',
    marginTop: 0,
  },
  downloadLink: {
    color: colors.xdHighlight,
  },
  button: {
    display: 'inline-block',
    background: 'none',
    width: '40px',
    height: '40px',
    // border: '1px solid rgba(0,22,66,0.32)',
    fill: colors.black,
    color: colors.black,
    position: 'relative',
    color: colors.black,
    fontSize: '1.4rem',
    padding: 0,
    verticalAlign: 'top'
  },
  buttonHov: {
    background: '#fff',
    color: colors.xdHighlight,
    boxShadow: '0 2px 3px rgba(0,0,0,0.3)',
    fill: colors.xdHighlight,
  },
  buttonActive: {
    background: colors.xdHighlight,
    fill: '#fff',
    color: '#fff',
    boxShadow: 'inset 0px 1px 3px rgba(0,0,0,0.24)'
  },
  buttonContent: {
    ...absCenter,
  },
  btnSvg: {
    width: '24px',
    height: '24px',
    display: 'block',
  },
  count: {
    fontSize: '1rem',
    lineHeight: '4px',
    display: 'block'
  },
  btnText: {
    marginTop: '3px',
    display: 'inline-block',
  },
  inlineAssets: {
    marginTop: '8px',
  }
}
